import React, { ReactNode } from 'react';
import classNames from 'classnames';
interface IProps {
  children: ReactNode;
  isHost?: boolean;
}

function SidePanelHeaderNav({ children, isHost = false }: IProps) {
  const className = classNames('novoSidePanel__header-nav', {
    'novoSidePanel__header-nav--host': isHost,
  });
  return <nav className={className}>{children}</nav>;
}

export default SidePanelHeaderNav;
